import { render, staticRenderFns } from "./OpenserveServiceRegrades.vue?vue&type=template&id=3cf947bd&scoped=true&"
import script from "./OpenserveServiceRegrades.vue?vue&type=script&lang=js&"
export * from "./OpenserveServiceRegrades.vue?vue&type=script&lang=js&"
import style0 from "./OpenserveServiceRegrades.vue?vue&type=style&index=0&id=3cf947bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf947bd",
  null
  
)

export default component.exports